import React, {useEffect} from 'react';
import { connect } from 'react-redux';
import { updateApp } from 'actions/app';
import { AppStatus, ViewStatus, AppViews } from 'resources/enums';
import Main from 'components/main';
import { helper } from 'helpers/appHelper';
import { resourceManager } from 'helpers/resourceManager';

function Index({app, updateApp}){

    useEffect(() => {
        let data = {
            // webApiHostUrl: webApiUrl,
            appView: AppViews.MAIN,
            viewStatus: ViewStatus.INIT,
            appStatus: AppStatus.STARTED,
            showLoader: true
        };
        resourceManager.setLanguage(helper.getLanguage(window.location.pathname));
        
        updateApp(data);
    }, []);

    
    let view = null;

    switch(app.appStatus) {
        case AppStatus.INITIALIZE:
            view = null;
            break;
        default:
            view = (<Main app={app}/>);
            break;
    }        
    
    return (view);
}

function mapStateToProps(state) {
    return {
        app: state.app
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateApp: (data) => {
            dispatch(updateApp(data));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);